// Which call-to-action a beat licence tier gets on the public beat page.
//
// Pure and dependency-free so the routing rules — especially "quote-only
// tiers never enter self-service checkout" — are testable across every
// published beat and tier combination without a browser or Stripe.
import { tierPriceFor } from "@/lib/bkls";

export type BeatTierCta = "owned" | "request" | "checkout";

export interface CtaTier {
  key: string;
  is_quote_only?: boolean | null;
  price_cents?: number | null;
  currency?: string | null;
}

export interface CtaInput {
  tier: CtaTier;
  beat: unknown;
  checkoutEnabled: boolean | null | undefined;
  owned: boolean;
}

/**
 * `checkout` is only ever returned for an unowned, non-quote-only tier that
 * resolves to a real price while checkout is open. Everything else falls back
 * to the custom-request flow, which is also what the server enforces.
 */
export function beatTierCta({ tier, beat, checkoutEnabled, owned }: CtaInput): BeatTierCta {
  if (owned) return "owned";
  if (tier.is_quote_only) return "request";
  const price = tierPriceFor(tier as never, beat as never);
  if (!price || price <= 0) return "request";
  if (!checkoutEnabled) return "request";
  return "checkout";
}
